import * as yup from "yup"

const fieldRequired = "Campo obrigatório."

export const schema = yup.object().shape({
  anlt_cname: yup.string().required(fieldRequired),
  anlt_type: yup.string().required(fieldRequired),
  anlt_bstatus: yup.boolean(),
  anlt_decimal_places: yup.number().when("anlt_type", {
    is: "Quantitativo",
    then: yup.number().typeError("É permitido de 0 a 5 casas decimais").min(0).max(5),
    otherwise: yup.number().nullable(),
  }),

  anlt_unit_of_measure: yup.string().when("anlt_type", {
    is: "Quantitativo",
    then: yup.string().required(fieldRequired),
    otherwise: yup.string().nullable(),
  }),

  anlt_observation: yup.string().nullable(),

  anlt_sector_nid: yup.number().required(fieldRequired),
  anlt_result_options: yup.array().when("anlt_type", {
    is: (val) => val === "Qualitativo" || val === "Semi-Quantitativo",
    then: yup
      .array()
      .test(
        "is-Semi-Quantitativo",
        "Selecione no mínimo 2 opções",
        (value) => value && value.length >= 2,
      ),
    otherwise: yup
      .array()
      .notRequired(),
  }),
})

export const schemaAddEquipament = yup.object().shape({
  equipment_cname: yup.string().required(fieldRequired),
  equipment_cserial_number: yup.string().required(fieldRequired),
  equipment_unit_nid: yup.string().required(fieldRequired).nullable(),
  equipment_sector_nid: yup.string().required(fieldRequired),
})



// export const schemaAddControl = yup.object().shape({
//   control_cname: yup.string().required(fieldRequired),
//   control_cmanufacturer: yup.string().required(fieldRequired),
//   control_elevel: yup.string().required(fieldRequired).nullable(),
//   control_cbatch: yup.string().required(fieldRequired),
//   control_dexpiration: yup.string().required(fieldRequired),

// })
